import { render, staticRenderFns } from "./CurrencyTable.vue?vue&type=template&id=1baf945c"
import script from "./CurrencyTable.vue?vue&type=script&lang=js"
export * from "./CurrencyTable.vue?vue&type=script&lang=js"
import style0 from "./CurrencyTable.vue?vue&type=style&index=0&id=1baf945c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports